var _defineProperty = require("/Users/ashishuniyal/Downloads/lms-student/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/Users/ashishuniyal/Downloads/lms-student/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/Users/ashishuniyal/Downloads/lms-student/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ashishuniyal/Downloads/lms-student/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/ashishuniyal/Downloads/lms-student/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/ashishuniyal/Downloads/lms-student/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/ashishuniyal/Downloads/lms-student/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/ashishuniyal/Downloads/lms-student/node_modules/@babel/runtime/helpers/inherits");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        _loop();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return to;
};

var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps( // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

  return value;
};

var ReactPlayer_exports = {};

__export(ReactPlayer_exports, {
  createReactPlayer: function createReactPlayer() {
    return _createReactPlayer;
  }
});

module.exports = __toCommonJS(ReactPlayer_exports);

var import_react = __toESM(require("react"));

var import_deepmerge = __toESM(require("deepmerge"));

var import_memoize_one = __toESM(require("memoize-one"));

var import_react_fast_compare = __toESM(require("react-fast-compare"));

var import_props = require("./props");

var import_utils = require("./utils");

var import_Player = __toESM(require("./Player"));

var Preview = (0, import_utils.lazy)(function () {
  return import(
  /* webpackChunkName: 'reactPlayerPreview' */
  "./Preview");
});
var IS_BROWSER = typeof window !== "undefined" && window.document && typeof document !== "undefined";
var IS_GLOBAL = typeof global !== "undefined" && global.window && global.window.document;
var SUPPORTED_PROPS = Object.keys(import_props.propTypes);
var UniversalSuspense = IS_BROWSER || IS_GLOBAL ? import_react.Suspense : function () {
  return null;
};
var customPlayers = [];

var _createReactPlayer = function _createReactPlayer(players, fallback) {
  var _a;

  return _a =
  /*#__PURE__*/
  function (_import_react$Compone) {
    "use strict";

    _inherits(_a, _import_react$Compone);

    function _a() {
      var _this;

      _classCallCheck(this, _a);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(_a).apply(this, arguments));

      __publicField(_assertThisInitialized(_this), "state", {
        showPreview: !!_this.props.light
      }); // Use references, as refs is used by React


      __publicField(_assertThisInitialized(_this), "references", {
        wrapper: function wrapper(_wrapper) {
          _this.wrapper = _wrapper;
        },
        player: function player(_player) {
          _this.player = _player;
        }
      });

      __publicField(_assertThisInitialized(_this), "handleClickPreview", function (e) {
        _this.setState({
          showPreview: false
        });

        _this.props.onClickPreview(e);
      });

      __publicField(_assertThisInitialized(_this), "showPreview", function () {
        _this.setState({
          showPreview: true
        });
      });

      __publicField(_assertThisInitialized(_this), "getDuration", function () {
        if (!_this.player) return null;
        return _this.player.getDuration();
      });

      __publicField(_assertThisInitialized(_this), "getCurrentTime", function () {
        if (!_this.player) return null;
        return _this.player.getCurrentTime();
      });

      __publicField(_assertThisInitialized(_this), "getSecondsLoaded", function () {
        if (!_this.player) return null;
        return _this.player.getSecondsLoaded();
      });

      __publicField(_assertThisInitialized(_this), "getInternalPlayer", function () {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "player";
        if (!_this.player) return null;
        return _this.player.getInternalPlayer(key);
      });

      __publicField(_assertThisInitialized(_this), "seekTo", function (fraction, type, keepPlaying) {
        if (!_this.player) return null;

        _this.player.seekTo(fraction, type, keepPlaying);
      });

      __publicField(_assertThisInitialized(_this), "handleReady", function () {
        _this.props.onReady(_assertThisInitialized(_this));
      });

      __publicField(_assertThisInitialized(_this), "getActivePlayer", (0, import_memoize_one.default)(function (url) {
        for (var _i = 0, _arr = [].concat(customPlayers, _toConsumableArray(players)); _i < _arr.length; _i++) {
          var player = _arr[_i];

          if (player.canPlay(url)) {
            return player;
          }
        }

        if (fallback) {
          return fallback;
        }

        return null;
      }));

      __publicField(_assertThisInitialized(_this), "getConfig", (0, import_memoize_one.default)(function (url, key) {
        var config = _this.props.config;
        return import_deepmerge.default.all([import_props.defaultProps.config, import_props.defaultProps.config[key] || {}, config, config[key] || {}]);
      }));

      __publicField(_assertThisInitialized(_this), "getAttributes", (0, import_memoize_one.default)(function (url) {
        return (0, import_utils.omit)(_this.props, SUPPORTED_PROPS);
      }));

      __publicField(_assertThisInitialized(_this), "renderActivePlayer", function (url) {
        if (!url) return null;

        var player = _this.getActivePlayer(url);

        if (!player) return null;

        var config = _this.getConfig(url, player.key);

        return (
          /* @__PURE__ */
          import_react.default.createElement(import_Player.default, _objectSpread({}, _this.props, {
            key: player.key,
            ref: _this.references.player,
            config: config,
            activePlayer: player.lazyPlayer || player,
            onReady: _this.handleReady
          }))
        );
      });

      return _this;
    }

    _createClass(_a, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps, nextState) {
        return !(0, import_react_fast_compare.default)(this.props, nextProps) || !(0, import_react_fast_compare.default)(this.state, nextState);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var light = this.props.light;

        if (!prevProps.light && light) {
          this.setState({
            showPreview: true
          });
        }

        if (prevProps.light && !light) {
          this.setState({
            showPreview: false
          });
        }
      }
    }, {
      key: "renderPreview",
      value: function renderPreview(url) {
        if (!url) return null;
        var _this$props = this.props,
            light = _this$props.light,
            playIcon = _this$props.playIcon,
            previewTabIndex = _this$props.previewTabIndex,
            oEmbedUrl = _this$props.oEmbedUrl,
            previewAriaLabel = _this$props.previewAriaLabel;
        return (
          /* @__PURE__ */
          import_react.default.createElement(Preview, {
            url: url,
            light: light,
            playIcon: playIcon,
            previewTabIndex: previewTabIndex,
            previewAriaLabel: previewAriaLabel,
            oEmbedUrl: oEmbedUrl,
            onClick: this.handleClickPreview
          })
        );
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            url = _this$props2.url,
            style = _this$props2.style,
            width = _this$props2.width,
            height = _this$props2.height,
            fallback2 = _this$props2.fallback,
            Wrapper = _this$props2.wrapper;
        var showPreview = this.state.showPreview;
        var attributes = this.getAttributes(url);
        var wrapperRef = typeof Wrapper === "string" ? this.references.wrapper : void 0;
        return (
          /* @__PURE__ */
          import_react.default.createElement(Wrapper, _objectSpread({
            ref: wrapperRef,
            style: _objectSpread({}, style, {
              width: width,
              height: height
            })
          }, attributes),
          /* @__PURE__ */
          import_react.default.createElement(UniversalSuspense, {
            fallback: fallback2
          }, showPreview ? this.renderPreview(url) : this.renderActivePlayer(url)))
        );
      }
    }]);

    return _a;
  }(import_react.Component), __publicField(_a, "displayName", "ReactPlayer"), __publicField(_a, "propTypes", import_props.propTypes), __publicField(_a, "defaultProps", import_props.defaultProps), __publicField(_a, "addCustomPlayer", function (player) {
    customPlayers.push(player);
  }), __publicField(_a, "removeCustomPlayers", function () {
    customPlayers.length = 0;
  }), __publicField(_a, "canPlay", function (url) {
    for (var _i2 = 0, _arr2 = [].concat(customPlayers, _toConsumableArray(players)); _i2 < _arr2.length; _i2++) {
      var Player2 = _arr2[_i2];

      if (Player2.canPlay(url)) {
        return true;
      }
    }

    return false;
  }), __publicField(_a, "canEnablePIP", function (url) {
    for (var _i3 = 0, _arr3 = [].concat(customPlayers, _toConsumableArray(players)); _i3 < _arr3.length; _i3++) {
      var Player2 = _arr3[_i3];

      if (Player2.canEnablePIP && Player2.canEnablePIP(url)) {
        return true;
      }
    }

    return false;
  }), _a;
};